<template>
  <v-app id="vuetify-app">
    <v-container fluid>
      <v-layout align-center justify-center row fill-height>
        <v-flex xs12 md4>
          <v-card>
            <v-card-title>
              <h3>
                {{ `app.mobile_app.registration.patient_registration` | trans }}
              </h3>
            </v-card-title>
            <v-card-text>
              <v-alert :value="isDietitian" type="warning">
                {{ `app.mobile_app.registration.dietitian_registration` | trans }}
              </v-alert>
              <v-form v-model="formValid" lazy-validation ref="registrationForm"
                      v-if="isDietitian === false && registrationSuccessful === false">
                <v-text-field
                    v-model="userData.firstName"
                    required
                    :rules="rules.first_name"
                    :label="`app.first_name` | trans "
                ></v-text-field>
                <v-text-field
                    v-model="userData.lastName"
                    required
                    :rules="rules.last_name"
                    :label="`app.surname` | trans "
                ></v-text-field>
                <v-text-field
                    v-model="userData.email"
                    type="email"
                    required
                    readonly
                    disabled
                    :rules="rules.email"
                    :label="`app.email` | trans"
                ></v-text-field>
                <v-text-field
                    v-model="userData.password"
                    type="password"
                    required
                    :rules="rules.password"
                    :label="`app.password` | trans"
                ></v-text-field>
                <v-text-field
                    v-model="userData.password_confirmation"
                    type="password"
                    required
                    :rules="rules.password_confirmation"
                    :label="`app.password_confirmation` | trans"
                ></v-text-field>
                <v-checkbox
                    v-model="userData.termsAndConditions"
                    :color="`success`"
                    :rules="rules.terms_and_conditions"
                    required
                >
                  <template v-slot:label>
                    <span v-html="getTermsAndConditionsLabel()"></span>
                  </template>
                </v-checkbox>
                <recaptcha :recaptcha-site-key="recaptchaSiteKey" ref="recaptcha"/>
                <v-btn :disabled="!formValid || loading" :loading="loading" color="primary"
                       @click="registerPatient">{{ `app.mobile_app.registration.register` | trans }}
                </v-btn>
              </v-form>
              <p v-if="registrationSuccessful">{{ `app.mobile_app.registration.patient_registered` | trans }}</p>
              <div v-if="registrationSuccessful">
                <mobile-app-download :app-store-link="appStoreLink" :google-play-link="googlePlayLink"/>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-app>
</template>

<script>
import axios from "axios";
import RulesBuilder from "../../utils/rulesBuilder";
import {trans} from "../../app";
import VueRecaptcha from 'vue-recaptcha';

export default {
  props: {
    email: String,
    firstName: String,
    lastName: String,
    isDietitian: Boolean,
    isPatient: Boolean,
    appStoreLink: String,
    googlePlayLink: String,
    routes: Object,
    recaptchaSiteKey: String,
  },
  components: {VueRecaptcha},
  data() {
    return {
      loading: false,
      formValid: false,
      userData: {
        email: "",
        firstName: "",
        lastName: "",
        password: "",
        password_confirmation: "",
        termsAndConditions: false,
      },
      rulesBuilder: new RulesBuilder(),
      registrationSuccessful: false,
    };
  },
  computed: {
    rules() {
      return {
        email: this.rulesBuilder.addRequiredRule(trans('app.email'))
            .addMaxLengthRule(trans('app.email'), 255)
            .getRules(),
        first_name: this.rulesBuilder.addRequiredRule(trans('app.first_name'))
            .addMaxLengthRule(trans('app.first_name'), 255)
            .getRules(),
        last_name: this.rulesBuilder.addRequiredRule(trans('app.surname'))
            .addMaxLengthRule(trans('app.surname'), 255)
            .getRules(),
        password: this.rulesBuilder.addRequiredRule(trans('app.password'))
            .addMinLengthRule(trans('app.password'), 8)
            .getRules(),
        password_confirmation: this.rulesBuilder.addRequiredRule(trans('app.password_confirmation'))
            .addMinLengthRule(trans('app.password'), 8)
            .addSameRule(trans('app.password'), trans('app.password_confirmation'), this.userData.password)
            .getRules(),
        terms_and_conditions: this.rulesBuilder.addRequiredRule('').getRules(),
      }

    }
  },
  mounted() {
    this.userData.email = this.email;
    this.userData.firstName = this.firstName;
    this.userData.lastName = this.lastName;
  },
  methods: {
    getTermsAndConditionsLabel() {
      return trans('app.acceptance_of_the_regulations');
    },
    registerPatient() {
      this.loading = true;

      if (this.$refs.registrationForm.validate() === false) {
        this.loading = false;
        this.$toast.error(trans('app.auth.registration.registration_failed'));
        return;
      }

      if (this.$refs.recaptcha.verify() === false) {
        this.loading = false;
        return;
      }

      axios.post(this.routes.register, {
        email: this.userData.email,
        first_name: this.userData.firstName,
        last_name: this.userData.lastName,
        password: this.userData.password,
        password_confirmation: this.userData.password_confirmation,
        terms_and_conditions: this.userData.termsAndConditions,
        g_recaptcha_response: this.$refs.recaptcha.getResponse(),
      }).then(() => {
        this.registrationSuccessful = true;
        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.$toast.error(trans('app.auth.registration.registration_failed'));
      })
    }
  }
};
</script>
<style scoped>
</style>
